import React, { useMemo } from 'react'

export const useHookAsHoc =
  (name, hook, mapper = (result) => result) =>
  (Wrapped) => {
    const Comp = (props) => {
      const result = hook(props)
      const mapped = useMemo(() => mapper(result), [result])
      return <Wrapped {...props} {...{ [name]: mapped }} />
    }

    Comp.displayName = `useHookAsHoc${hook.name}`

    return Comp
  }
